<template>
    <VuePerfectScrollbar class="scroll-area" :settings="psSettings" @ps-y-reach-end="scrollHandle">
        <ul class="messages">
            <template v-for="(extensible, index) in extensibles">
                <ExtensibleItem 
                  :key="index+'-'+type" 
                  :extensible="extensible"
                  @show-extensible-view="showExtensibleView"
                  @show-extensible-selection="showExtensibleSelection"
                  :isActive="activeExtensible == extensible"
                />
            </template>
        </ul>
    </VuePerfectScrollbar>
</template>

<script>
import Vue from "vue"
import { mapGetters, mapActions, mapState } from "vuex"
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import ExtensibleItem from '@/components/extensible-sms/ExtensibleItem'
import {extensibleTypes} from '@/constants'
import {EventBus} from '@/events/bus.event'

export default {
  name: 'ExtensibleList',
  components: {
    ExtensibleItem,
    VuePerfectScrollbar,
  },
  data () {
    return {
      extensibleTypes: extensibleTypes,
      activeExtensible: null
    }
  },
  props: {
    type: String,
    isQuestionnaire: Boolean,
    extensibles: {
      type: Array,
      required: true,
      default: () => []
    }
  },
  computed: {
    psSettings: () => {
      return {
        maxScrollbarLength: 60,
        minScrollbarLength: 40,
        suppressScrollX: getComputedStyle(document.querySelector('html')).direction !== 'rtl',
        wheelPropagation: false,
        interceptRailY: styles => ({ ...styles, height: 0 })
      }
    }
  },
  created: function() {
    EventBus.$on('extensible-selection-none', this.resetSelection)
  },
  methods: {
    showChooseType: function() {
        this.$emit('show-extensible-type-chooser', this.type, this.isQuestionnaire)
    },
    scrollHandle (evt) {
      //this.$emit('load-more-birthday-groups')
    },
    showExtensibleView(evt) {
      this.activeExtensible = evt
      this.$emit('show-extensible-view', evt)
    },
    showExtensibleSelection(evt, selected) {
      this.activeExtensible = evt
      this.$emit('show-extensible-selection', evt, selected)
    },
    resetSelection() {
      this.activeExtensible = null
    },
  }
}
</script>

<style scoped lang="css">
  @media (max-width: 768px) {
    .scroll-area {
      height: calc(100vh - 13vh);
    }
  }
  @media (min-width: 768px) {
    .scroll-area {
      position: relative;
      height: calc(100vh - 18vh);
    }
  }
</style>

